import { useTranslation } from "@coworker/locales";
import FixaSSRIcon from "../../../shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import WarningTrianglePath from "../../../shared/wrappers/FixaSSRIcon/paths/WarningTrianglePath";
import styles from "./task-notification.module.css";

export const TaskNotificationSafety = () => {
  const { t } = useTranslation();
  return (
    <div className={styles["task-notification-item-body-priority"] ?? ""}>
      <FixaSSRIcon paths={WarningTrianglePath} />
      {t("safetyAlarmString")}
    </div>
  );
};
